import { createReducer, generateHashFromObject } from '../../lib/Utils'
import { GET_STATS_FULFILLED } from './actions'

const initialState = {}

export default createReducer(initialState, {
  [GET_STATS_FULFILLED]: (state, action) => {
    const hash = generateHashFromObject(action.payload.params)
    let stats = { ...state.stats } || { byParamsHash: {} }
    let statsByParamsHash = { ...stats.byParamsHash } || {}
    statsByParamsHash[hash] = action.payload.response
    stats.byParamsHash = statsByParamsHash

    return { ...state, stats }
  },
})
